import { Injectable } from '@angular/core';
import { BundleOptionSelection, IBundleOptionSelectionSelection } from '@df/catalog/product/bundle-option-selection';
import { BundleSelection } from '@df/catalog/product/bundle-selection';
import { IProductDataBundleOption, IProductDataV3, Product } from '@df/catalog/product/product';

@Injectable({ providedIn: 'root' })
export class BundleOptionSelectionFactory {
    static instance = BundleOptionSelection;

    create(
        bundleSelection: BundleSelection,
        bundleOption: IProductDataBundleOption,
        data?: IBundleOptionSelectionSelection
    ): BundleOptionSelection {
        return new BundleOptionSelectionFactory.instance(bundleSelection, bundleOption, data);
    }

    protected getComponentPrice(product: Product<IProductDataV3>, orgPrice: boolean): number {
        return orgPrice ? product.orgPrice || product.price : product.price;
    }
}
